import React from 'react';
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {SelectV2} from "../forms/FormEl";

const ProductosFormSelect = React.forwardRef((props, ref) => {

  const {data, loading} = useFetch2(Apis.PROD + '/producto/list', []);

  return (
    <>
      {
        !loading ?
          <SelectV2 ref={ref} options={data.map(item=>({id: item.id,name: item.codigo + ' - ' + item.nombre}))} {...props}/>
          :
          <SelectV2 disabled options={[{id: 0, name: 'Cargando...'}]}/>
      }
    </>
  )
})

export default ProductosFormSelect;
